import { h, Component } from 'preact';
import s from 'components/bolt/debugInfo/debugInfo.sss';
// import { accessNested } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
// import DeviceDetector from 'device-detector-js';

const importers = [
	'flicks',
	'cinepolis',
	'cinemex',
	'ingresso',
	'velox',
	'yandex',
	'kinohod',
	'rambler',
	'cinergy',
	'outnow',
	'ntlive',
	'byexp',
	'pathe',
	'faf',
	'vue',
	'webedia',
	'cpass',
	'mx',
	'pow',
	'amc',
	'atom'
];

export default class DebugInfo extends Component {
	constructor(props) {
		super(props);

		this.updateInfo = this.updateInfo.bind(this);
	}

	componentDidMount() {
		// this.deviceDetector = new DeviceDetector();
		this.updateInfo();

		window.addEventListener('resize', this.updateInfo);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateInfo);
	}

	updateInfo() {
		const userAgent = window.navigator.userAgent;
		// const device = this.deviceDetector.parse(userAgent);

		const cleanBrowserName = { Edg: 'Edge', OPR: 'Opera' };
		let uaIndicators = [...userAgent.matchAll(/([^ ]+)\/([\d.]+)/g)].map(([, name, version]) => ({
			name: cleanBrowserName[name] || name,
			version
		}));
		const uaSubsets = {
			Safari: ['Chrome'],
			Chrome: ['SamsungBrowser']
		};
		let browser = uaIndicators.pop();
		while (browser?.name in uaSubsets) {
			let next = uaIndicators.pop();
			if (!uaSubsets[browser.name].includes(next.name)) {
				break;
			}
			browser = next;
		}
		const osMatch = userAgent.match(/\([^;]*;\s*([^;)]+)\s*(?:;[^)]*)?\)/);
		const os = osMatch?.[1] || 'unknown OS';

		// const deviceModel = device.device.brand + ' ' + device.device.model;
		// const os = device.os.name + ' ' + device.os.version;
		// const browser = device.client.name + ' ' + device.client.version;

		let zoom = window.visualViewport?.scale;
		if (zoom === 1) {
			// Can be wrong on some high-density pixel screens but whatev
			// Can also use window.outerWidth / window.innerWidth in some cases but not universal either
			// test page (tap text to refresh): https://cdpn.io/pen/debug/MWVmMpj/e46de905095437e04945ad64a7530aa5
			zoom = window.devicePixelRatio;
		}

		this.setState({
			// userAgentInfo: deviceModel + ' - ' + os + ' - ' + browser,
			userAgentInfo: `${browser.name} ${browser.version} (${os})`,
			userAgentSource: userAgent,
			browserWindowSize: window.innerWidth + 'x' + window.innerHeight,
			screenResolution: window.screen.width + 'x' + window.screen.height,
			availScreenSpace: window.screen.availWidth + 'x' + window.screen.availHeight,
			browserZoomPercentage: (zoom * 100).toFixed(2) + '%',
			browserLanguage: navigator.language
		});
	}

	render({ appData, appState }, state) {
		const {
			userAgentInfo,
			userAgentSource,
			browserWindowSize,
			screenResolution,
			availScreenSpace,
			browserZoomPercentage,
			browserLanguage
		} = state;

		let activePage = appState.activePage;
		let showtimesPage = 'boltShowtimes';
		if (appData?.pages?.[activePage]?.type === 'showtimes') {
			showtimesPage = activePage;
		}
		let showtimesData = appData?.pages?.[showtimesPage]?.data;

		const appId = appData?.meta?.id;
		const movieId = showtimesData?.movieId || '-';
		const city = appState?.client?.geo?.city;
		const country = appState?.client?.geo?.countryName;

		let buildDate = 'unknown';
		if (typeof window !== 'undefined') {
			buildDate = formatDateTime(window.__BUILD_DATE__, 'yyyy-MM-dd hh:mm');
		}

		const deeplinkProviders = showtimesData?.providers?.deeplink?.split(',')?.map(provider => {
			let index = importers.indexOf(provider.trim()) + 1;
			return index || 'unknown';
		}) || ['-'];

		const showtimesProviders = showtimesData?.providers?.showtimes?.split(',')?.map(provider => {
			let index = importers.indexOf(provider.trim()) + 1;
			return index || 'unknown';
		}) || ['-'];

		return (
			<div class={s.wrapper}>
				<div class={s.line}>
					App ID: <span>{appId}</span>
				</div>
				<div class={s.line}>
					Region: <span>{__REGION__.toUpperCase()}</span>
				</div>
				<div class={s.line}>
					Last Published: <span>{buildDate}</span>
				</div>
				<div class={s.line}>
					Movie ID: <span>{movieId}</span>
				</div>
				<div class={s.line}>
					Screenings Providers: <span>{showtimesProviders.join(', ')}</span>
				</div>
				<div class={s.line}>
					Deeplink Providers: <span>{deeplinkProviders.join(', ')}</span>
				</div>
				<div class={s.line}>
					Browser Language: <span>{browserLanguage}</span>
				</div>
				<div class={s.line}>
					Approx Location: <span>{city + ', ' + country}</span>
				</div>
				<div class={s.line}>
					User-Agent: <span title={userAgentSource}>{userAgentInfo}</span>
				</div>
				<div class={s.line}>
					Browser Window Size: <span>{browserWindowSize}</span>
				</div>
				<div class={s.line}>
					Screen Res: <span>{screenResolution}</span>
				</div>
				<div class={s.line}>
					Avail Screen Space: <span>{availScreenSpace}</span>
				</div>
				<div class={s.line}>
					Browser Zoom Level: <span>{browserZoomPercentage}</span>
				</div>
			</div>
		);
	}
}
